/**
 * Social Reader module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import AdminSocialProvider from '@src/SocialReader/Pages/Fields/AdminSocialProvider.vue';
import GridSocialProvider from '@src/SocialReader/Pages/Fields/GridSocialProvider.vue';

export const setup = (app: App<Element>): void => {
    app.component('AdminSocialProvider', AdminSocialProvider);
    app.component('GridSocialProvider', GridSocialProvider);
};
